import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import api from '@/lib/api';
import { formatDateTimePt } from '@/components/Badges';

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);

  useEffect(() => { api.get('/admin/audit-logs?limit=200').then((r) => setLogs(r.data)); }, []);

  return (
    <div className="space-y-4">
      <div>
        <div className="font-display text-4xl text-white">LOGS DE AUDITORIA</div>
        <p className="text-muted-foreground">Registro de todas as ações administrativas.</p>
      </div>
      <Card className="border border-border bg-card">
        <CardContent className="p-0">
          <div className="divide-y divide-border">
            {logs.length === 0 ? (
              <div className="p-8 text-center text-muted-foreground">Nenhum log registrado.</div>
            ) : logs.map((l) => (
              <div key={l.id} className="p-3 grid grid-cols-1 md:grid-cols-[180px_1fr_140px] gap-2 text-sm">
                <div className="text-xs text-muted-foreground font-mono">{formatDateTimePt(l.created_at)}</div>
                <div>
                  <div className="text-white"><span className="text-[var(--g66-amber)] font-medium">{l.action}</span> em {l.entity_type}</div>
                  {l.details && Object.keys(l.details).length > 0 && (
                    <div className="text-xs text-muted-foreground font-mono truncate">{JSON.stringify(l.details)}</div>
                  )}
                </div>
                <div className="text-xs text-muted-foreground truncate">{l.user_email || l.user_id}</div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
